import { ActionToButton } from 'components/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { CardProps } from './types';

type Props = CardProps & {
  title: string;
  imgSrc: string;
  dappUrl: string;
  infoUrl: string;
};

const DappCard: React.FC<Props> = ({ title, imgSrc, dappUrl, infoUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <a href={dappUrl} target="_blank" rel="noreferrer" className="block space-y-1 md:space-y-2">
        <img src={imgSrc} alt="" className="w-full mx-auto" />
        <span className="block">{title}</span>
      </a>
      <ActionToButton actionTo={infoUrl} actionTitle={t('dapps.learn_more')} isThemed={false} />
    </div>
  );
};

export default DappCard;
